import script from "./editjiaoxuesheji.vue?vue&type=script&setup=true&lang=js"
export * from "./editjiaoxuesheji.vue?vue&type=script&setup=true&lang=js"

import "./editjiaoxuesheji.vue?vue&type=style&index=0&id=4b3d0b3c&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b3d0b3c"]])

export default __exports__